export const DocumentVersionType = {
    BASIC: "BASIC",
    PRO: "PRO",
    EXPERT: "EXPERT"
}

export  class DocumentVersion{

    static isBasic(){
        return !(DocumentVersion.isPro() || DocumentVersion.isExpert())
    }

    static isPro(){
        return process.env.VUE_APP_VERSION == DocumentVersionType.PRO
    }

    static isExpert(){
        return process.env.VUE_APP_VERSION == DocumentVersionType.EXPERT
    }

    static getVersionType(){
        return process.env.VUE_APP_VERSION
    }

}